module.exports = __webpack_public_path__ + "img/antes_despues_42.49a22eb5.png";